import Dot from 'components/Dot/Dot';
import { pitchTypeGroupToColor, pitchTypeToColor } from 'utilities/colorHelpers';

type Props = {
  pitchLocation: string;
  pitchType: string;
  playerType: 'Batter' | 'Pitcher';
};

function getVerticalPosition(pitchLocation: string): string {
  const value = pitchLocation.split('|')[0].trim();
  switch (value) {
    case 'Above':
      return '-35%';
    case 'Top':
      return '25%';
    case 'Middle':
      return '50%';
    case 'Bottom':
      return '75%';
    case 'Below':
      return '135%';
    default:
      return '0%';
  }
}

function getHorizontalPosition(pitchLocation: string, playerType: 'Batter' | 'Pitcher'): string {
  const value = pitchLocation.split('|')[2]?.trim();
  switch (value) {
    case 'RightOf':
      return playerType === 'Pitcher' ? '135%' : '-35%';
    case 'Right':
      return playerType === 'Pitcher' ? '75%' : '25%';
    case 'Middle':
      return '50%';
    case 'Left':
      return playerType === 'Pitcher' ? '25%' : '75%';
    case 'LeftOf':
      return playerType === 'Pitcher' ? '-35%' : '135%';
    default:
      return '0%';
  }
}

const PitchLocationCell = ({ pitchLocation, pitchType, playerType }: Props) => {
  return (
    <div style={{ position: 'relative', height: '30px', width: '26px', margin: '6px', border: '1px solid black' }} title={pitchLocation}>
      <div
        style={{
          position: 'absolute',
          top: getVerticalPosition(pitchLocation),
          left: getHorizontalPosition(pitchLocation, playerType),
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Dot color={pitchTypeToColor[pitchType] ?? pitchTypeGroupToColor[pitchType]} />
      </div>
    </div>
  );
};

export default PitchLocationCell;
